import { render, staticRenderFns } from "./resource-card.vue?vue&type=template&id=6bdbdc26"
import script from "./resource-card.js?vue&type=script&lang=js&external"
export * from "./resource-card.js?vue&type=script&lang=js&external"
import style0 from "./resource-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports